import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import BylineWithHeadshot from '@components/BylineWithHeadshot';
import ProExclusiveLogo from '@components/ProExclusiveLogo';
import ProjectTitle from '@components/ProjectTitle';
import useDatawrapperResize from '@hooks/useDatawrapperResize';
import { Project, ProjectMedia } from '@interfaces/projects';
import { ACCESS_PRO } from '@src/constants';
import { dateInLocalTimezone } from '@utils/dates';

import Media from '../Database/Media';

type TopSectionProps = Pick<
  Project,
  'accessLevel' | 'authors' | 'description' | 'title' | 'titleCallout' | 'updatedAt'
> & {
  mediaSourcePath: string;
  projectMedia?: ProjectMedia[];
};

const TopSection = ({
  accessLevel,
  authors,
  description,
  mediaSourcePath,
  projectMedia,
  title,
  titleCallout,
  updatedAt,
}: TopSectionProps): JSX.Element => {
  useDatawrapperResize();

  return (
    <div className="mx-auto max-w-container-lg pt-16">
      {accessLevel >= ACCESS_PRO && <ProExclusiveLogo />}
      <ProjectTitle className="!mb-16" title={title} titleCallout={titleCallout} />
      {authors?.length > 0 && (
        <div className="flex flex-col items-center justify-center gap-8 sm:flex-row sm:gap-0">
          <BylineWithHeadshot
            authors={authors}
            className="font-suisse-screen text-byline-sm text-primary-black sm:text-byline-lg"
          />{' '}
          <span className="hidden px-12 text-[20px] sm:inline">\</span>{' '}
          <p className="font-suisse-screen text-description-sm font-normal italic text-grayscale-gray">
            Last updated{' '}
            <time dateTime={new Date(updatedAt).toISOString()}>
              {dateInLocalTimezone(updatedAt)}
            </time>
          </p>
        </div>
      )}
      {projectMedia && projectMedia?.length > 0 ? (
        <div className="flex flex-col flex-wrap items-center justify-between gap-40 md:mt-64 md:flex-row md:items-start">
          <div className="my-18 w-full flex-grow md:w-5/12">{ReactHtmlParser(description)}</div>
          {projectMedia.map((media) => (
            <Media key={media.id} media={media} mediaSourcePath={mediaSourcePath} />
          ))}
        </div>
      ) : (
        <div className="mx-auto mt-16 w-full max-w-[690px] text-center font-noto-serif text-caption-lg font-normal text-primary-black">
          {ReactHtmlParser(description)}
        </div>
      )}
    </div>
  );
};

export default TopSection;
